// extracted by mini-css-extract-plugin
export default {"search-filter":"xNMnc"};